<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutAlign="center center">
    <h3 class="logout-loading" i18n="userswitch|userswitch message@@userswitch_text_switching_user">Switching User</h3>
    <wd-apollo-spinner size="80"></wd-apollo-spinner>
  </div>
</div>
